import { ICollaboratorSchema } from "@wingspanhq/payments/dist/interfaces";
import React, { ReactNode } from "react";
import { useCollaboratorsQuery } from "../../../query/payments/queries";
import { getVisibleCollaborators } from "../../../query/payments/selectors";
import { WSQueries } from "../../../query/WSQuery";
import { usePayablesQuery } from "../NewPayablesTable/PayablesTable";

type Props = {
  loader?: ReactNode;
  zeroState?: ReactNode;
  children: (collaborators: ICollaboratorSchema[]) => ReactNode;
  limit?: number;
};

export const RecentCollaboratorsContainer: React.FC<Props> = ({
  loader,
  children,
  zeroState,
  limit
}) => {
  const collaboratorsQuery = useCollaboratorsQuery();
  const payablesQuery = usePayablesQuery();

  return (
    <WSQueries
      queries={{ collaboratorsQuery }}
      renderLoader={loader ? () => loader : undefined}
    >
      {({ collaboratorsQuery }) => {
        const payables = payablesQuery.data?.data || [];

        const collaborators = getVisibleCollaborators(collaboratorsQuery.data);

        const dataToSort = collaborators.map(collaborator => {
          const datesToCompare = [collaborator.createdAt.getTime()];

          payables
            .filter(
              invoice => invoice.collaboratorId === collaborator.collaboratorId
            )
            .forEach(invoice => {
              datesToCompare.push(invoice.createdAt.getTime());
            });

          return {
            collaborator,
            latestActionAt: new Date(Math.max(...datesToCompare))
          };
        });

        dataToSort.sort((a, b) => {
          return a.latestActionAt < b.latestActionAt ? 1 : -1;
        });

        const recentMemberClients = dataToSort
          .map(item => item.collaborator)
          .slice(0, limit);

        return recentMemberClients.length > 0
          ? children(recentMemberClients)
          : zeroState
          ? zeroState
          : null;
      }}
    </WSQueries>
  );
};
